import { useState, useEffect } from "react";
import isBrowserContext from "helpers/isBrowserContext";

export default (navigate?: any, location?: any) => {
    const [originalLocation, setOriginalLocation] = useState<string | undefined>(undefined);
    const [previousUrl, setPreviousUrl] = useState<string>("");

    useEffect(() => {
        if (isBrowserContext()) {
            window.dataLayer = window.dataLayer || [];

            if (location) {
                // Fixes "The Rogue Referral Problem" for Single-page sites
                // https://www.simoahava.com/gtm-tips/fix-rogue-referral-problem-single-page-sites/
                const currentLocation = document.location.protocol + "//" + document.location.hostname + document.location.pathname + document.location.search;
                if (typeof (originalLocation) === "undefined") {
                    setOriginalLocation(currentLocation);

                    // Trigger on all sites
                    window.dataLayer.push({
                        "event": "Heyday.FirstPageview",
                        "eventTimeout": 2000,
                        "originalLocation": currentLocation
                    });
                }
            }
        }
    }, []);

    useEffect(() => {
        if (isBrowserContext() && location && originalLocation) {
            const url = location.pathname + location.search;

            if (previousUrl !== url && previousUrl !== "") {
                window.dataLayer.push({
                    "event": "Heyday.SubsequentPageview",
                    "eventTimeout": 2000,
                    "originalLocation": originalLocation
                });
            }
            
            setPreviousUrl(url);
        }
    }, [location?.pathname, location?.search]);

    return;
};